<template>
<div class="furnish-main">
  <div style="margin-bottom: 5px;">
    <el-button size="mini" type="primary" v-if="mainObj.id" @click="startFlow" :disabled="allow">发起验收流程</el-button>
    <el-button size="mini" type="warning" v-if="form.check_task_id" @click="lookFlow">查看流程</el-button>
  </div>
  <el-descriptions title="" :column="1" border label-style="width: 120px;">
    <el-descriptions-item label="完工确认表">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="完工确认表" >
        <el-link type="primary" class="el-link-common" @click="getFile('P41-01-03装修施工完工确认表.doc')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
  </el-descriptions>
</div>
</template>

<script>
import FitmentFileSubgroup from "./components/FitmentFileSubgroup";
import AppConfig from "../../../../../../config/AppConfig";
export default {
  name: "DecorationAcceptance",
  components: {FitmentFileSubgroup},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{
      form:{},
      allow: true
    }
  },
  mounted() {
    this.getData()
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getFurnish",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.form=ret.data;
          if(ret.data.ProcessState==4) {
            that.allow = false
          }
          if(ret.data.check_task_id) {
            that.allow = true
          }
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    startFlow(){
      const that=this;
      let timeValue=(new Date()).getTime();
      ERP.navigateTo(`/flow/FlowView?sheet_id=168&master_id=135&house_id=${that.form.HouseID}&fitment_id=${that.form.ID}&timeValue=${timeValue}`)
    },
    lookFlow(){
      const that=this;
      let timeValue=(new Date()).getTime();
      ERP.navigateTo(`/flow/FlowView?sheet_id=168&master_id=135&task_id=${that.form.check_task_id}`)
    },
    getFile(file_name) {
      // let url=AppConfig.erp_server+"/excel/house/"+file_name;
      let url=AppConfig.erp_server+"/admin/HouseFurnish/download?file_name="+file_name;
      window.open(url, "_blank");
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/DecorationAcceptance.vue